import { DBMessageLogThunks } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { Box } from "@mui/material";
import React, { useEffect, useState } from 'react';
import ExtensionSidebarContactList from './extension-sidebar-contact-list';
import ExtensionSidebarSearchBox from "./extension-sidebar-search-box";
import classes from "./scheduled-contact-list.module.scss";


export function ScheduledContactList(): React.ReactElement {
  console.log("ScheduledContactList rendered");
  const calendarViewOpen = useAppSelector((state) => state.MainReducer.calendarViewOpen);

  if (!calendarViewOpen) {
    return <></>;
  }
  return (
      <Box sx={{
        zIndex: 1000,
        position: 'relative',
        direction: 'inherit',
        height: "100%",
      }}>
        <ExtensionSidebarSearchBox />
        <ExtensionSidebarContactList />
      </Box>
  );
}
